import { FC } from "react";
import style from "./ModalVideo.module.scss";

export interface Props {
  url: string;
  close: () => void;
  useIframe?: boolean;
}

export const ModalVideo: FC<Props> = ({ url, close, useIframe = true }) => {
  return (
    <div className={style.videoContenaire}>
      <div>
        <div>
          <button type="button" onClick={close} className={style.btnClose}>
            close
          </button>
          {useIframe ? (
            <iframe
              width="740"
              height="380"
              src={url}
              title="videoFrame"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            >
              &amp;
            </iframe>
          ) : (
            <video width="740" height="380" controls autoPlay>
              <source src={url} type="video/mp4" />
              <track kind="captions" src="" srcLang="en" label="English" />
            </video>
          )}
        </div>
      </div>
    </div>
  );
};
